export const WAIT_BEFORE_SLIDES_IS_ACTIVE = 3000;
